


























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { CollectionEventDetailsModel } from "@/api/CollectionEvents";
import isAfter from "date-fns/isAfter";
import sub from "date-fns/sub";
import startOfDay from "date-fns/startOfDay";
import userStore from "@/store/userStore";
import { createVideoRequest, VideoRequestStatus } from "@/api/VideoRequest";
import VideoRequestViewDialog from "@/components/VideoRequests/VideoRequestViewDialog.vue";
import { videoUrl } from "@/api/VideoRequest";

@Component({ components: { VideoRequestViewDialog } })
export default class CollectionEventDetailsList extends Vue {
  userStore = userStore;
  videoUrl = videoUrl;
  @Prop(Object) readonly details?: CollectionEventDetailsModel;
  @Prop(Boolean) readonly isCollectionIssue?: boolean;
  VideoRequestStatus = VideoRequestStatus;
  isVideoOpen = false;
  isCreatingVideoRequest = false;
  selectedVideoUrl: string | null = null;

  wasteStream(wasteStreamId: number) {
    if (userStore.councilConfiguration) return userStore.councilConfiguration.wasteConfiguration.find(wasteConfig => wasteConfig.id === wasteStreamId)?.name;
  }

  async createVideoRequest() {
    if (!this.details) return;
    this.isCreatingVideoRequest = true;
    const success = await createVideoRequest({ collectionEventId: this.details.id, isCollectionIssue: this.details.isCollectionIssue });
    if (success) {
      this.details.videoRequestStatus = VideoRequestStatus.InProgress;
      if (this.details.videoRequestsRemaining && !this.userStore.isStaff()) {
        this.details.videoRequestsRemaining--;
      }
    }
    this.isCreatingVideoRequest = false;
  }

  canRequestVideo() {
    if (!this.details) return false;
    const isWithinLast30Days = isAfter(startOfDay(new Date(this.details.eventDateTimeOffset)), startOfDay(sub(new Date(), { days: 31 })));
    return isWithinLast30Days && this.userStore.canAccessVideoRequests() && !this.details.isFromBinInspector;
  }

  viewPropertyVideo(videoRequestId: number) {
    this.selectedVideoUrl = videoUrl(videoRequestId, "Left");
    this.isVideoOpen = true;
  }

  viewRearVideo(videoRequestId: number) {
    this.selectedVideoUrl = videoUrl(videoRequestId, "Rear");
    this.isVideoOpen = true;
  }

  viewFrontVideo(videoRequestId: number) {
    this.selectedVideoUrl = videoUrl(videoRequestId, "Front");
    this.isVideoOpen = true;
  }

  viewHopperVideo(videoRequestId: number) {
    this.selectedVideoUrl = videoUrl(videoRequestId, "Inside");
    this.isVideoOpen = true;
  }

  onVideoRequestViewDialogClose() {
    setTimeout(() => {
      this.selectedVideoUrl = "";
    }, 300);
    this.isVideoOpen = false;
  }
}
